import { dollarsFromCents } from '@lib/helpers/format'
import type { BillingState, LockReason } from '@lib/enums/billing-state.enum'
import type { BillingSummaryDto } from '@lib/dto/billing-summary.dto'

/** What each billing state is called on screen. */
export const BILLING_STATE_LABELS: Record<BillingState, string> = {
  signup_incomplete: 'Signup incomplete',
  trialing: 'Trial',
  active: 'Active',
  cancelling: 'Canceling',
  past_due: 'Payment failed',
  locked: 'Locked',
  trial_cancelled: 'Trial canceled',
  comped: 'Comped',
  comp_ending: 'Comp ending',
}

/** Why a company is locked, in the words its billing owner reads. */
export const LOCK_REASON_TEXT: Record<LockReason, string> = {
  non_payment: 'A payment failed and wasn’t made within the grace period.',
  cancelled: 'The subscription was canceled and has reached the end of its paid period.',
  comp_ended: 'The complimentary plan ended without a subscription taking its place.',
}

/** A calendar date for a billing deadline — a real instant, shown in the reader’s zone. */
export function billingDateLabel(at: string): string {
  return new Date(at).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' })
}

/** Dollars from cents, for the bill: "$30". The same formatter the emails use. */
export const dollars = dollarsFromCents

/** The one date that matters next for a company in this state, labeled — or null. */
export function billingDeadline(billing: BillingSummaryDto): { label: string; at: string } | null {
  switch (billing.state) {
    case 'trialing':
      return billing.trialEndsAt ? { label: 'Trial ends', at: billing.trialEndsAt } : null
    case 'past_due':
      return { label: 'Locks on', at: billing.graceEndsAt }
    case 'comp_ending':
      return billing.compEndsAt ? { label: 'Comp ends', at: billing.compEndsAt } : null
    case 'cancelling':
      return billing.currentPeriodEndsAt ? { label: 'Ends on', at: billing.currentPeriodEndsAt } : null
    case 'trial_cancelled':
      return { label: 'Deleted on', at: billing.deletesAt }
    default:
      return null
  }
}
